import { createRequestTypes } from 'common/websocket-redux';

export const GET_GROUPS = createRequestTypes('employers/GET_GROUPS');
export const SEARCH_PAGE_REQUESTED = 'employers/SEARCH_PAGE_REQUESTED';
export const SEARCH_TEXT_CHANGED = 'employers/SEARCH_TEXT_CHANGED';
export const EMPLOYER_SELECTED = 'employers/EMPLOYER_SELECTED';
